import { css } from '@emotion/react'

import { borderRadius, breakpoint, size } from '@twisto/styles'

export const root = css`
  &:not(:last-of-type) {
    margin-bottom: ${size[24]};
  }

  ${breakpoint.up('sm')} {
    padding: ${size[32]} ${size[48]};
    border-radius: ${borderRadius.sm};
  }

  ${breakpoint.up('md')} {
    padding: ${size[64]} ${size[80]};
  }

  ${breakpoint.down('xs')} {
    padding: 0;
    background: transparent;
    box-shadow: none;
  }
`
